<template>
  <v-navigation-drawer color="#eceff4" v-model="isOpen" fixed temporary left>
    <v-list>
      <v-list-item :to="{ name: 'report' }">
        <v-list-item-content>
          <v-list-item-title class="pb-2">Report</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'comparison' }">
        <v-list-item-content>
          <v-list-item-title class="py-2">Datenanalyse-Tool</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'benchmarking' }">
        <v-list-item-content>
          <v-list-item-title class="py-2"
            >Digital-Schnellcheck</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item :to="{ name: 'methodology' }">
        <v-list-item-content class="py-2">
          <v-list-item-title class="py-4">Über die Studie</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Drawer",
  data: () => ({
    isOpen: false
  })
};
</script>
